import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false
};


export default function physical_group (state = initialState, action) {
  switch (action.type) {
    case types.SET_PHYSICAL_GROUP_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_PHYSICAL_GROUP_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}